import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const initialState = {
    isEInvoiceShowed: false,
    cities: [],
    awsFiscalCode: '',
    isLoading: false,
    eInvoiceEnable: false,
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.getFiscalCodeRequest, (state) => ({
        ...state,
        awsFiscalCode: '',
    }))
        .addCase(actions.getFiscalCodeSuccess, (state, { payload }) => ({
        ...state,
        awsFiscalCode: payload?.data?.fiscalCode,
    }))
        .addCase(actions.setIsEInvoiceShowed, (state, { payload }) => ({
        ...state,
        isEInvoiceShowed: payload,
    }))
        .addCase(actions.getCitiesRequest, (state) => ({
        ...state,
        isLoading: true,
        cities: [],
    }))
        .addCase(actions.getCitiesSuccess, (state, { payload }) => ({
        ...state,
        isLoading: false,
        cities: payload?.data?.data?.suggestItalianCitiesStartingWith?.items || [],
    }))
        .addCase(actions.clearInvoiceCities, (state) => ({
        ...state,
        cities: [],
    }))
        .addCase(actions.setEInvoiceEnableParam, (state, { payload }) => ({
        ...state,
        eInvoiceEnable: payload,
    }));
});
